<script>
import countlyVue from '../../compat/vue-core';
import FormCommons from './commons';

export default countlyVue.components.BaseComponent.extend({
  mixins: [FormCommons.BaseFormField],
  props: {
    subheading: { required: false },
    label: { required: false },
    linkTabIndex: {
      type: Number,
      default: -1,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    disableFormWrapping: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
      required: false,
    },
    flex: {
      type: Boolean,
      default: false,
      required: false,
    },
    link: {
      type: Object,
    },
    tooltip: { type: String, default: null },
    passwordValidation: {
      type: Boolean,
      default: false,
    },
    hideValidationError: {
      type: Boolean,
      default: false,
    },
    labelXl: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperElement() {
      if (this.disableFormWrapping) {
        return 'div';
      }
      return 'form';
    },
    topClasses() {
      if (this.inline) {
        return null;
      }
      return 'cly-vue-form-step__section';
    },
  },
});
</script>
<template>
  <div
    class="cly-vue-form-field"
    :class="topClasses"
  >
    <div class="bu-is-flex bu-is-justify-content-space-between">
      <div>
        <div
          v-if="!inline || tooltip || label || optional"
          class="bu-is-flex bu-is-justify-content-space-between items-center"
        >
          <div
            v-if="label"
            class="font-medium text-[13px]"
            :class="[labelXl ? 'font-medium text-md leading-5' : '']"
          >
            {{ label }}
          </div>
          <cly-tooltip-icon
            v-if="tooltip"
            class="bu-is-flex-grow-1 bu-ml-2 text-cool-gray-40"
            :tooltip="tooltip"
          />
          <div
            v-show="optional"
            class="text-small text-heading color-cool-gray-40"
          >
            {{ $t("common.optional") }}
          </div>
        </div>
        <div
          v-if="subheading"
          class="color-cool-gray-50 text-small bu-mb-1"
        >
          {{ subheading }}
        </div>
      </div>
      <div v-if="link">
        <a
          :tabindex="linkTabIndex"
          class="text-sm text-linkblue"
          :href="link.url"
        >{{ link.text }}</a>
      </div>
    </div>
    <component
      :is="wrapperElement"
      @submit.prevent
    >
      <validation-provider
        v-if="rules"
        v-slot="validation"
        :rules="rules + '|noHtml'"
        :bails="bails"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <div
          class="cly-vue-form-field__inner el-form-item"
          :class="{'is-error': validation.errors.length > 0, 'flex': flex}"
        >
          <slot
            v-bind="validation"
            :rule-status="ruleStatus(validation)"
          />
        </div>
        <div
          v-if="!hideValidationError && validation.errors.length && !passwordValidation"
          class="text-warning text-sm flex w-full mt-2 items-center"
        >
          <div class="flex items-center text-sm h-3">
            <div>
              <img
                src="@/assets/images/warning-icon.svg"
                alt="warning-icon"
              >
            </div>
            <div class="ml-2">
              {{ $t(`mycountly.validations.${Object.keys(validation.failedRules)[0]}`) }}
            </div>
          </div>
        </div>
      </validation-provider>
      <div
        v-else
        class="cly-vue-form-field__inner el-form-item"
      >
        <slot />
      </div>
    </component>
  </div>
</template>
